import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useUserFlags } from '../../hooks/useUserFlags';
import { Loader2 } from 'lucide-react';

interface AdminRouteProps {
  children: ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { currentUser, loading } = useAuth();
  const userFlags = useUserFlags(currentUser && !currentUser.isAnonymous ? currentUser.uid : null);

  if (loading || userFlags.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!currentUser || currentUser.isAnonymous) {
    return <Navigate to="/auth" replace />;
  }

  if (!userFlags.isAdmin && !userFlags.isOwner) {
    return <Navigate to="/projects" replace />;
  }

  return <>{children}</>;
}
